import { InvitedProfileDto, Role, UserProfileDto } from '@inosio/payments-sdk';
import { Box, Button, IconButton, Modal, Stack, Typography } from '@mui/material';
import CloseModalIcon from '../../icons/RoundCloseIcon.svg';
import RegisteredIcon from '../../icons/RegisteredIcon.svg';
import NotRegisteredIcon from '../../icons/NotRegisteredIcon.svg';
import ProfileUserCard from './ProfileUserCard';
import { useState } from 'react';
import { SubjectDetailsPassReset, usePasswordResetConfigs } from '../../pmui/residents/hooks/usePasswordResetConfigs';
import useRegInviteConfigs, { SubjectDetailsInvitation } from '../../pmui/residents/hooks/useRegInviteConfigs';
import RegInviteModal from '../../pmui/residents/InviteResident';
import ResetPasswordModal from '../../pmui/residents/ResetPassword';
import { UserRegistrationProfileDetails } from './UserRegistrationModalManager';
import CreateNewProfileUserModal from './CreateNewProfileUserModal';

interface ProfileUsersModalProps {
  open: boolean;
  onClose: () => void;
  handleAddNewUser: () => void;
  profileUsers: UserProfileDto[];
  profileInvitedUsers: InvitedProfileDto[];
  profileDetails: UserRegistrationProfileDetails;
}
const ProfileUsersModal = (props: ProfileUsersModalProps) => {
  const [openUpdateInvitationProfileUserModal, setOpenUpdateInvitationProfileUserModal] = useState(false);
  const [openInvitationModal, setOpenInvitationModal] = useState(false);
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
  const [subjDetailsInvitation, setSubjDetailsInvitation] = useState<SubjectDetailsInvitation>({
    ProfileUuid: props.profileDetails.profileUuid ?? '',
    Email: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    RoleType: Role.Resident, //just a fallback
  });
  const [subjDetailsPassReset, setSubjDetailsPassReset] = useState<SubjectDetailsPassReset>({
    ProfileUuid: props.profileDetails.profileUuid ?? '',
    UserUuid: '',
    Email: '',
    CreatedAt: '',
  });

  const handleClickProfileRegisteredUser = (userUuid: string, email: string, createdAt: string) => {
    const subjectDetails: SubjectDetailsPassReset = {
      ProfileUuid: props.profileDetails.profileUuid,
      UserUuid: userUuid,
      Email: email,
      CreatedAt: createdAt,
    };
    setSubjDetailsPassReset(subjectDetails);
    setOpenResetPasswordModal(true);
    props.onClose();
  };

  const handleClickProfileInvitedUser = (tokenId: string, email: string, firstName: string, lastName: string, middleName?: string) => {
    const subjectDetails: SubjectDetailsInvitation = {
      ProfileUuid: props.profileDetails.profileUuid,
      Email: email,
      FirstName: firstName,
      MiddleName: middleName,
      LastName: lastName,
      RoleType: props.profileDetails.profileRole,
      TokenId: tokenId,
    };

    setSubjDetailsInvitation(subjectDetails);
    if(!subjectDetails.FirstName || !subjectDetails.LastName || !subjectDetails.Email){
      setOpenUpdateInvitationProfileUserModal(true)
      props.onClose()
    }else{
      setOpenInvitationModal(true);
      props.onClose();
    }
    
    
  };

  const handleCloseModal = () => {
    setOpenInvitationModal(false);
    setOpenResetPasswordModal(false);
  };

  const regInviteModalConfigs = useRegInviteConfigs({ handleCloseModal, subjectDetails: { ...subjDetailsInvitation }, openModal: openInvitationModal });
  const passwordResetModalconfigs = usePasswordResetConfigs({ handleCloseModal, subjectDetails: { ...subjDetailsPassReset }, openModal: openResetPasswordModal });
  return (
    <Box>
      <Modal open={props.open} onClose={props.onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box
          sx={{
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 520,
            background: '#FFFFFF',
            boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
            borderRadius: '24px',
            p: 4,
            outline: 'none',
            minHeight: '523px',
          }}
        >
          <Stack direction="column" justifyContent="start" alignItems="space-between" spacing={2}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ position: 'relative' }}>
              <Typography
                style={{
                  fontFamily: '"Work Sans",Sans serif',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: '18px',
                  lineHeight: '22px',
                  color: '#14142B',
                  margin: '0 !important',
                }}
              >
                Select user or add new
              </Typography>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="Close modal"
                onClick={props.onClose}
                sx={{
                  position: 'absolute',
                  right: 0,
                }}
              >
                <img src={CloseModalIcon} alt="close" />
              </IconButton>
            </Stack>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="center"
              spacing={3}
              sx={{
                maxHeight: '380px',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  width: 7,
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                  borderRadius: '24px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'darkgrey',
                  borderRadius: '24px',
                },
              }}
            >
              {props.profileUsers.map((pu) => {
                return (
                  <ProfileUserCard
                    key={pu.UserUuid}
                    name={`${pu.FirstName || ''} ${pu.MiddleName ||''} ${pu.LastName || ''}`}
                    email={pu.UserEmail}
                    image={RegisteredIcon}
                    onClick={() => {
                      handleClickProfileRegisteredUser(pu.UserUuid, pu.UserEmail, pu.RegistrationDate);
                    }}
                  />
                );
              })}
              {props.profileInvitedUsers.map((piu) => {
                return (
                  <ProfileUserCard
                    key={piu.TokenId}
                    name={`${piu.FirstName || ''} ${piu.MiddleName || ''} ${piu.LastName ||''}`}
                    email={piu.InvitedEmail || ''}
                    image={NotRegisteredIcon}
                    onClick={() => {
                      handleClickProfileInvitedUser(
                        piu.TokenId,
                        piu.InvitedEmail,
                        piu.FirstName,
                        piu.LastName,
                        piu.MiddleName,
                      );
                    }}
                  />
                );
              })}
            </Stack>
          </Stack>
          <Box
            style={{
              position: 'absolute',
              bottom: '20px',
              left: '24px',
              right: '24px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="outlined"
              sx={{ borderRadius: '24px', fontFamily: 'Work Sans !important', textTransform: 'capitalize', color: '#39A2DB', borderColor: '#39A2DB', width: '187px' }}
              onClick={props.handleAddNewUser}
            >
              Add New User
            </Button>
          </Box>
        </Box>
      </Modal>
      {openInvitationModal ? <RegInviteModal {...regInviteModalConfigs} /> : <></>}
      {openResetPasswordModal ? <ResetPasswordModal {...passwordResetModalconfigs} /> : <></>}
     <CreateNewProfileUserModal
        open={openUpdateInvitationProfileUserModal}
        onClose={() => {
          setOpenUpdateInvitationProfileUserModal(false);
          props.onClose();
        }}
        profileDetails={{
          ...props.profileDetails,
          profileIntegrationEmail: subjDetailsInvitation.Email,
          profileIntegrationFirstName: subjDetailsInvitation.FirstName,
          profileIntegrationLastName: subjDetailsInvitation.LastName,
          profileIntegrationMiddleName: subjDetailsInvitation.MiddleName || '',
          profileRole: subjDetailsInvitation.RoleType,
          profileUuid: subjDetailsInvitation.ProfileUuid,
          UpdateTokenId: subjDetailsInvitation.TokenId
        }}
        profileUsers={props.profileUsers}
        profileInvitedUsers = {props.profileInvitedUsers}
      />
    </Box>
  );
};

export default ProfileUsersModal;
